import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Inline from 'syf-component-library/ui/spacing/Inline';
import { Stack } from 'syf-component-library/ui/spacing';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledFlex } from '../../../styles/common';
import { StyledText, StyledTitle } from '../../../styles/text';
import { colors } from '../../../styles/theme';
import { FontAwesomeComponent } from '../icons/transaction-type-icons';
import { StyledTransactionDetail } from './subcomponents';
const isFontAwesomeIcon = (icon) => {
    return 'icon' in icon;
};
const TransactionDetail = ({ detail, heading, icon, iconColor = colors.cyanBlue, title, translationObject }) => {
    const isMobile = useDeviceWidth();
    if (!detail)
        return null;
    const fontAwesomeIcon = isFontAwesomeIcon(icon);
    return (_jsxs(StyledTransactionDetail, { direction: isMobile ? 'column' : 'row', children: [_jsxs(StyledFlex, { as: "dt", alignItems: "center", children: [fontAwesomeIcon ? (_jsx(FontAwesomeComponent, { title: title, translationObject: translationObject !== null && translationObject !== void 0 ? translationObject : 'activityDetails', icon: icon, color: iconColor })) : (icon), _jsx(Inline, { size: "medium" }), _jsx("header", { style: { zIndex: 2 }, children: _jsx(StyledTitle, { as: "h6", weight: "regular", children: heading }) })] }), _jsxs("dd", { children: [_jsx(Stack, { size: "small" }), _jsx(StyledText, { as: "span", weight: "bold", align: isMobile ? 'start' : 'right', children: detail })] })] }));
};
export default TransactionDetail;
//# sourceMappingURL=index.js.map